import { render, staticRenderFns } from "./YoutubeTutorial.vue?vue&type=template&id=16952343&scoped=true"
import script from "./YoutubeTutorial.vue?vue&type=script&lang=js"
export * from "./YoutubeTutorial.vue?vue&type=script&lang=js"
import style0 from "./YoutubeTutorial.vue?vue&type=style&index=0&id=16952343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16952343",
  null
  
)

export default component.exports